import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-268582f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "giveUsAStar" }
const _hoisted_2 = { href: "https://github.com/relizaio/rebom" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Rebom - Catalog of Software Bills of Materials", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Bom Version "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Group "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Name "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Version "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Actions ")
  ])
], -1))
const _hoisted_5 = { class: "text-left" }
const _hoisted_6 = { class: "text-left" }
const _hoisted_7 = { class: "text-left" }
const _hoisted_8 = { class: "text-left" }
const _hoisted_9 = { class: "text-left" }
const _hoisted_10 = ["href"]
const _hoisted_11 = ["href"]
const _hoisted_12 = {
  key: 0,
  style: {"margin-top":"10px","margin-left":"5px"},
  class: "leftText"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_feather = _resolveComponent("vue-feather")!
  const _component_n_input = _resolveComponent("n-input")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_input_group = _resolveComponent("n-input-group")!
  const _component_n_form = _resolveComponent("n-form")!
  const _component_n_table = _resolveComponent("n-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("a", _hoisted_2, [
        _createVNode(_component_vue_feather, { type: "github" })
      ])
    ]),
    _hoisted_3,
    _createElementVNode("div", null, [
      _createVNode(_component_n_form, {
        inline: "",
        onSubmit: $setup.userSearch
      }, {
        default: _withCtx(() => [
          _createVNode(_component_n_input_group, null, {
            default: _withCtx(() => [
              _createVNode(_component_n_input, {
                class: "leftText",
                placeholder: "BOM Search Query",
                value: $setup.searchQuery,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (($setup.searchQuery) = $event))
              }, null, 8, ["value"]),
              _createVNode(_component_n_button, {
                variant: "contained-text",
                onClick: $setup.userSearch
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Find ")
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ]),
    _createVNode(_component_n_table, { style: {"margin-top":"30px"} }, {
      default: _withCtx(() => [
        _hoisted_4,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.boms, (b) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: b.uuid
            }, [
              _createElementVNode("td", _hoisted_5, _toDisplayString(b.bomVersion), 1),
              _createElementVNode("td", _hoisted_6, _toDisplayString(b.group), 1),
              _createElementVNode("td", _hoisted_7, _toDisplayString(b.name), 1),
              _createElementVNode("td", _hoisted_8, _toDisplayString(b.version), 1),
              _createElementVNode("td", _hoisted_9, [
                _createElementVNode("a", {
                  href: '/restapi/bomById/' + b.uuid,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  title: "Open Bom in New Tab"
                }, [
                  _createVNode(_component_vue_feather, { type: "eye" })
                ], 8, _hoisted_10),
                _createElementVNode("a", {
                  href: '/restapi/bomById/' + b.uuid + '?download=true',
                  target: "_blank",
                  rel: "noopener noreferrer",
                  title: "Download Bom"
                }, [
                  _createVNode(_component_vue_feather, { type: "download" })
                ], 8, _hoisted_11)
              ])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }),
    (!$setup.boms || !$setup.boms.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, " No BOMs found. "))
      : _createCommentVNode("", true)
  ]))
}